import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonServiceService } from '../services/common-service.service';
import { InsightsService } from '../insights/insights.service';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { NgOtpInputComponent, NgOtpInputConfig } from 'ng-otp-input';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css'],
})
export class EditProfileComponent implements OnInit {
  merchantDetails: any;
  bussinessDetails: any;
  regenerateAPI_key: any;
  copyApiKey: any;
  delay = 50;
  hideDelay: any;

  constructor(
    private service: CommonServiceService,
    private insigntsService: InsightsService,
    private _snackBar: MatSnackBar,
    private _matDialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.merchantDetails = JSON.parse(localStorage.getItem('merchantDetails'));
    this.getMerchantBusinessDetails();
  }

  getMerchantBusinessDetails() {
    this.service.getBusinessDetails().subscribe((res) => {
      this.bussinessDetails = res;
    });
  }

  copyKey() {
    this.copyApiKey = localStorage.getItem('apiKey');
    // this._snackBar.open('Copied to clipboard', 'close', {
    //   duration: 2000,
    //   horizontalPosition: 'end',
    //   verticalPosition: 'top',
    // });
  }

  regenereteApiKeyPopup() {
    this._matDialog.open(RegenereteApiKeyDialog);
  }
}

@Component({
  selector: 'regenerate-apikey-dialog',
  templateUrl: 'regenerate-apikey-dialog.html',
  styleUrls: ['./edit-profile.component.css'],
})
export class RegenereteApiKeyDialog {
  botID: any;
  copyURL: any;
  apiKeyRegenereted: boolean = false;
  merchantDetails: any;
  regenerateAPI_key: any;
  regenerateOtp: any;
  constructor(
    public dialogRef: MatDialogRef<RegenereteApiKeyDialog>,
    private insigntsService: InsightsService,
    private _snackBar: MatSnackBar,
    private _matDialog: MatDialog,
    private service: CommonServiceService
  ) {
    this.merchantDetails = JSON.parse(localStorage.getItem('merchantDetails'));
  }

  closePopup() {
    this.dialogRef.close();
  }

  emailVerifyPopup() {
    this._matDialog.open(VerifyEmailDialog);
  }

  // regenereteApiKey() {
  //   this.insigntsService
  //     .generateApiKey(this.merchantDetails.merchant_id)
  //     .subscribe(
  //       (res) => {
  //         this.regenerateAPI_key = res.api_key;
  //         this.apiKeyRegenereted =true
  //         localStorage.setItem('apiKey', this.regenerateAPI_key);
  //       },
  //       (error) => {
  //         if (error.error.message) {
  //           this._snackBar.open(error.error.message, 'close', {
  //             duration: 4000,
  //             horizontalPosition: 'end',
  //             verticalPosition: 'top',
  //           });
  //         }
  //       }
  //     );
  // }

  getApiKeyOTP() {
    this.service
      .getApiKeyOTP(this.merchantDetails.merchant_id)
      .subscribe((res) => {
        this.regenerateOtp = res;
      });
  }
}

@Component({
  selector: 'verify-email-dialog',
  templateUrl: 'verify-email-dialog.html',
  styleUrls: ['./edit-profile.component.css'],
})
export class VerifyEmailDialog {
  @ViewChild(NgOtpInputComponent, { static: false })
  ngOtpInput: NgOtpInputComponent;
  apiKeyRegenereted: boolean = false;
  
  otp: number;
  timeLeft: number = 40;
  interval: any;
  otpNumber;
  merchantDetails: any;
  newAPIKey: string;
  showNotification: boolean = false;
  notificationMessage: string;
  invalidOtpNotification:boolean = false;
  InvalidMessage: string;
  config: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    inputStyles:{'border': '1px solid #C3D2FC'},
    isPasswordInput: false,
    disableAutoFocus: true,
    placeholder: '',
  };
  constructor(
    public dialogRef: MatDialogRef<VerifyEmailDialog>,
    private service: CommonServiceService,
    private insigntsService: InsightsService
  ) {
    this.merchantDetails = JSON.parse(localStorage.getItem('merchantDetails'));
    this.startTimer();
  }

  onOtpChange(otp) {
    if(otp == ""){
      this.config.inputStyles ={'border': '1px solid #C3D2FC'}
    }
    this.otp = otp;
  }
  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft != 0) {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          this.timeLeft = 40;
        }
      } else {
        this.timeLeft = 0;
      }
    }, 1000);
  }

  closePopup() {
    this.dialogRef.close();
  }

  confirmOTP() {
    this.config.inputStyles ={'border': '1px solid #C3D2FC'}
    let request = {
      otp: this.otp,
    };
    this.service
      .verifyApiKeyOTP(this.merchantDetails.merchant_id, request)
      .subscribe((res) => {
        let response = JSON.parse(res);
        let token = response.token;
        let request ={
          "token":token
        }
        this.insigntsService.generateApiKey(this.merchantDetails.merchant_id,request).subscribe(res => {
          this.apiKeyRegenereted = true;
          localStorage.setItem('apiKey',res.body.api_key)
        }, error => {
          this.apiKeyRegenereted = false;
        })
        
      },(error)=>{
          let wrongOtp = JSON.parse(error.error)
          if(wrongOtp.message){
            this.invalidOtpNotification=true;
            this.config.inputStyles ={'border': '1px solid #EB5757'}
            this.InvalidMessage = wrongOtp.message
          }
          setTimeout(()=>{                         
            this.invalidOtpNotification = false;
            
        }, 4000);
      });
  }

  resendOTP() {
    this.service.getApiKeyOTP(this.merchantDetails.merchant_id).subscribe(
      (res) => {},
      (error) => {
        let errorMessage= JSON.parse(error.error)
        if (errorMessage.message) {
          this.showNotification = true;
          this.notificationMessage = errorMessage.message;
        }
        setTimeout(()=>{                         
          this.showNotification = false;
      }, 4000);
      }
    );
  }
}
